export * from './InlinePageForm';

import InlinePageForm from './InlinePageForm';
export default InlinePageForm;
